import { getLogger } from '@confluence/logger';
import { PERSISTED_KEYS_ON_SERVER } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';
import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance.ts';

const logger = getLogger('EditorControlsPinningPreference');

export type BannerType = 'toolbar-top' | 'toolbar-inline';
type BannerDismissal = {
	count?: number;
	firstViewed?: number;
};

type LocalStorageItem = {
	[key in BannerType]?: BannerDismissal;
};

const NEW_PINNING_STORAGE_KEY =
	PERSISTED_KEYS_ON_SERVER.PERSISTED_EDITOR_CONTROLS_ONBOARDING_BANNER_NEW_PINNING_DISMISSED;

const getLocalStorageItem = (): LocalStorageItem | undefined => {
	try {
		const itemString = localStorage.getItem(NEW_PINNING_STORAGE_KEY);
		if (!itemString) {
			return undefined;
		}

		const item = JSON.parse(itemString);
		if (
			typeof item === 'object' &&
			item !== null &&
			!Array.isArray(item) &&
			Object.keys(item).every((key) => ['toolbar-top', 'toolbar-inline'].includes(key))
		) {
			return item;
		}
	} catch (error) {
		logger.error`Error parsing local storage key(${NEW_PINNING_STORAGE_KEY}): ${error}`;
	}

	return undefined;
};

export const persistBannerDismissalNewPinning = (bannerType: BannerType): void => {
	let item = getLocalStorageItem();
	if (!item) {
		item = { [bannerType]: { count: 0 } };
	} else {
		const existingDismissal = item[bannerType];
		item[bannerType] = {
			...existingDismissal,
			count: 0,
		};
	}

	try {
		localStorage.setItem(NEW_PINNING_STORAGE_KEY, JSON.stringify(item));
	} catch (error) {
		logger.error`Error setting local storage key(${NEW_PINNING_STORAGE_KEY}): ${error}`;
	}
};
